<template>
    <div class="hero__content" :class="{'hero__content--video' : hero_is_video}">
        <div class="hero_img_container">
            <video autoplay muted loop class="hero__deco hero__deco--video" v-if="hero_is_video" >
                <source :src="home_hero_desktop_video" type="video/mp4">
            </video>
            <img v-else class="hero__deco" :src="home_hero_desktop_image"
                 :alt="home_hero_alt">
        </div>
        <div class="composition_tag animated-tag" v-if="has_composition_tag"><img src="/images/composition_tags/tag_fr.png" alt="offre 2€/2 mois"></div>
    </div>
</template>

<script>
import image_mixin from "../../_commons/fr/mixins/image_mixin";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

// IF YOU WANT TO DELETE THE ANIMATION, JUST REMOVE THE CLASS "animated-tag" FROM THE DIV
export default {
    mixins: [
        image_mixin
    ],
    mounted() {
        gsap.registerPlugin(ScrollTrigger);

        gsap.to(".animated-tag", {
            scrollTrigger: {
                trigger: "body",
                start: "top top",
                end: "170 top",
                scrub: 3
            },
            rotationY: 360,
            scale: 1.1,
            transformOrigin: "50% 50%",
            duration: 5,
            ease: "power2.inOut"
        });
    }
}

</script>

<style scoped>

</style>
